import { lazy } from 'react';

import { DCR_MANAGEMENT_ROLES } from 'common/utils/dcrConstants';

export const routes = [
    {
        component: lazy(() => import('module/dcrmanagement/DCRManagementPage')),
        permissions: [],
        role: DCR_MANAGEMENT_ROLES,
        path: '/dcrmanagement/:studyId',
    },
];
